import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalService {
  itemValue = new BehaviorSubject(this.theItem);

  set theItem(value) {
    this.itemValue.next(value);
    localStorage.setItem('currentRoute', JSON.stringify(value));
  }

  get theItem() {
    return localStorage.getItem('currentRoute');
  }
}
